<template>
  <div>
    <div class="row">
      <div class="col d-flex align-items-end">
        <small v-show="showWarningMessage" class="remark">
          Caution: The pickup store list is not updated.<br />
          Please save the privilege to get the updated list.</small
        >
      </div>

      <div class="col d-flex justify-content-end align-items-center">
        <label for="searchText" class="mx-3">Search: </label>
        <input
          id="searchText"
          type="text"
          v-model="filterItem"
          class="form-control w-50"
        />
      </div>
    </div>
    <b-table
      id="pickup-store-table"
      class="table table-responsive table-bordered mt-0"
      :per-page="perPage"
      :current-page="currentPage"
      :fields="fields"
      :items="items"
      :filter="filterItem"
      @filtered="onFiltered"
      hover
      responsive
    >
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="pickup-store-table"
    ></b-pagination>
  </div>
</template>

<script>
import fields from "./fieldsSamplePickupStores.json";
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    showWarningMessage: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      fields,
      currentPage: 1,
      perPage: 5,
      rows: 1,
      filterItem: "",
    };
  },
  mounted() {
    this.rows = this.items.length;
  },
  methods: {
    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-title {
  font-weight: 900;
}

.download-sample-file-link {
  color: #6e6e6e;
}

.remark {
  color: #ff0000;
}
</style>
